import { Box, Button, FormControl, IconButton, InputLabel, MenuItem, Select, TextField } from '@mui/material';

import React, { useEffect, useState } from 'react';
import { MdDelete } from 'react-icons/md';
import { useSnackbar } from 'notistack';
import { fetchPredefinedRulesList } from "../api's/DataProcessorApi";

const PredefinedRuleSelector = ({
  uniqueId,
  columnName,
  selectedColumnName,
  handleUniqueId,
  handleAdd,
  metricList,
  handleDelete,
  configDataNew,
  handleChange,
  disableForm,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const criteria = [
    {
      label: 'String',
      value: 'string',
    },
    {
      label: 'Number',
      value: 'number',
    },
    {
      label: 'Boolean',
      value: 'boolean',
    },
  ];

  const [predefinedRuleList, setPredefinedRuleList] = useState([]);

  const getPredefinedRuleList = async () => {
    try {
      const response = await fetchPredefinedRulesList();
      if (response.status === 200) {
        setPredefinedRuleList(response.data);
      }
    } catch (error) {
      enqueueSnackbar('Error while fetching Predefined Rule List!', {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
    }
  };

  useEffect(() => {
    getPredefinedRuleList();
  }, []);

  // const handleChangeStatement = (event, index) => {
  //   const { name, value } = event.target;

  //   handleChange(,index);
  // };

  return (
    <>
      <Box sx={{ marginTop: '16px' }}>
        {configDataNew?.map((data, i) => (
          <Box
            component="form"
            key={data.id}
            sx={{
              '& .MuiTextField-root': { m: 1, width: '35ch' },
              marginTop: '12px',
            }}
            noValidate
            autoComplete="off"
          >
            <FormControl style={{ width: '20%', margin: '0px 2% 8px 0' }} size="small">
              <InputLabel>Column Name</InputLabel>
              <Select
                id="demo-simple-select-helper"
                name="field_name"
                size="small"
                label="Column Name"
                value={data.field_name}
                onChange={(e) => handleChange(e, i)}
                key={data.id}
                disabled={disableForm}
                sx={{ background: '#ffffff' }}
              >
                {columnName.field_name
                  ? columnName
                      ?.sort((a, b) => a.field_name?.localeCompare(b.field_name))
                      ?.map((item) => (
                        <MenuItem key={item.id} value={item.field_name}>
                          {item.field_name}
                        </MenuItem>
                      ))
                  : columnName
                      ?.sort((a, b) => a.header?.localeCompare(b.header))
                      ?.map((item) => (
                        <MenuItem key={item.id} value={item.header}>
                          {item.header}
                        </MenuItem>
                      ))}
              </Select>
            </FormControl>
            {/* <FormControl style={{ width: '20%', margin: '0px 2% 8px 0' }} size="small">
              <InputLabel>Data type</InputLabel>
              <Select
                id="demo-simple-select-helper"
                name="dataType"
                size="small"
                label="Data type"
                // value={data.dataType}
                value="string"
                onChange={(e) => handleChange(e, i)}
                key={data.id}
                disabled
                sx={{ background: '#ffffff' }}
              >
                {criteria.map((item) => (
                  <MenuItem key={item.label} value={item.value}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl> */}

            <FormControl style={{ width: '20%', margin: '0px 2% 8px 0' }} size="small">
              <InputLabel>Category</InputLabel>
              <Select
                id="demo-simple-select-helper"
                name="category"
                size="small"
                label="Category"
                value={data.category}
                onChange={(e) => handleChange(e, i)}
                key={data.id}
                disabled={disableForm}
                sx={{ background: '#ffffff' }}
              >
                {predefinedRuleList
                  ?.sort((a, b) => a.category?.localeCompare(b.category))
                  ?.map((item) => (
                    <MenuItem key={item.rm_id} value={item.category}>
                      {item.category}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>

            {data.category && (
              <>
                <FormControl style={{ width: '20%', margin: '0px 2% 8px 0' }} size="small">
                  <InputLabel>Rule Name</InputLabel>
                  <Select
                    id="demo-simple-select-helper"
                    name="rule_name"
                    size="small"
                    label="Rule Name"
                    value={data.rule_name}
                    onChange={(e) => {
                      handleChange(e, i);
                      const statement_value =
                        predefinedRuleList
                          ?.filter((item) => data.category === item.category)
                          ?.flatMap((item) => item.rules_list)
                          ?.find((item) => e.target.value === item.rule_name)?.format || '';
                      const event = {
                        target: {
                          name: 'statement',
                          value: statement_value,
                        },
                      };
                      handleChange(event, i);
                    }}
                    key={data.id}
                    disabled={disableForm}
                    sx={{ background: '#ffffff' }}
                  >
                    {predefinedRuleList
                      ?.filter((item) => data.category === item.category)
                      ?.flatMap((item) => item.rules_list) // .sort((a, b) => a.category?.localeCompare(b.category))
                      ?.map((item) => (
                        <MenuItem key={item.ru_id} value={item.rule_name}>
                          {item.rule_name}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>

                <FormControl style={{ width: '20%', margin: '0px 0 8px 0' }} size="small">
                  <InputLabel>Metric</InputLabel>
                  <Select
                    id="demo-simple-select-helper"
                    name="metric"
                    size="small"
                    label="Metric"
                    value={data.metric}
                    onChange={(e) => handleChange(e, i)}
                    key={data.id}
                    disabled={disableForm}
                    sx={{ background: '#ffffff' }}
                  >
                    {metricList
                      ?.sort((a, b) => a.metric_type?.localeCompare(b.metric_type))
                      ?.map((item) => (
                        <MenuItem key={item.rm_id} value={item.metric_type}>
                          {item.metric_type}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
                <TextField
                  style={{ width: '64%', margin: '0px 2% 8px 0' }}
                  label="Statement"
                  id="outlined-size-small"
                  margin="none"
                  name="statement"
                  key={data.id}
                  size="small"
                  disabled
                  // onChange={(e) => handleChange(e, i)}
                  value={data.statement}
                  // value={
                  //   predefinedRuleList
                  //     ?.filter((item) => data.category === item.category)
                  //     ?.flatMap((item) => item.rules_list)
                  //     ?.find((item) => data.rule_name === item.rule_name)?.format || ''
                  // }
                />
              </>
            )}

            {/* <TextField
              style={{ width: '20%', margin: '0px 2% 8px 0' }}
              label="Rule name"
              id="outlined-size-small"
              margin="none"
              name="rule_name"
              key={data.id}
              size="small"
              disabled={disableForm}
              onChange={(e) => handleChange(e, i)}
              value={data.rule_name}
            /> */}

            <IconButton aria-label="expand row" size="medium" disabled={disableForm} onClick={() => handleDelete(data)}>
              <MdDelete />
            </IconButton>
          </Box>
        ))}
      </Box>

      <Button
        variant="contained"
        sx={{
          display: 'flex',
          marginTop: '8px',
          alignContent: 'flex-start',
          backgroundColor: '#00043C',
          '&:hover': { backgroundColor: '#00043C' },
        }}
        onClick={handleAdd}
        disabled={disableForm}
      >
        Add Predefined Rules
      </Button>
    </>
  );
};

export default PredefinedRuleSelector;
